module.exports = {
	"next": "siguiente",
	"skip": "Crear directamente su Cozy",
	"cancel": "anular",
	"back": "volver",
	"sign up": "inscribirse",
	"add email": "añadir una cuenta email",
	"welcome": "¡Vamos pues!",
	"confirm": "confirmar",
	"user missing properties": "Lo sentimos, pero este ususrio no existe.",
	"step welcome user": "Bienvenido(a) %{name}!",
	"step welcome anon": "Bienvenido(a)!",
	"step welcome logout": "¿Usted no es %{name}?",
	"step welcome congrats": "Felicitaciones, gracias a usted, sus datos personales se encuentran en lugar seguro, en su Cozy.",
	"step welcome next": "Siguiente",
	"step agreement title": "Condiciones Generales de Uso",
	"step agreement subtitle": "Para poder acceder a su Cozy usted ha leido y aceptado nuestras condiciones generales de uso. Si, como cualquiera de nosotros, usted no las lee nunca, he aqui un resumen de estas últimas :",
	"step agreement element 0": "Control y responsabilidad sobre sus datos, ¡y en casa!",
	"step agreement element 1": "Nosotros lo(a) protegemos a usted y a su cozy...",
	"step agreement element 2": "... al menos que usted haga algo equivocado con Cozy o con sus datos",
	"step agreement element 3": "Escoja que servicios pueden usar sus datos y  con qué objetivo",
	"step agreement element 4": "Nadie (ni siquiera nosotros) podemos accede a los datos de su Cozy",
	"step agreement element 5": "Disponemos sólo de algunos datos sobre usted, por razones legales o de la calidad del servicio",
	"step agreement stats": "Permito a Cozy reunir datos de manera anónima",
	"step agreement description 1": "Usted puede acceder a la totalidad de las condiciones generales",
	"step agreement description 2": "Al hacer clic en el botón \"acepto\"; usted reconoce que ha leído, entendido y aceptado estar de acuerdo con estas condiciones.",
	"step agreement description link": "aquí.",
	"step agreement next": "Acepto",
	"step preset": "ajustes",
	"step import": "importar sus datos",
	"step email settings": "configurar su email",
	"preset email": "e-mail",
	"preset email tip": "Esta dirección email puede ser útil para contactarlo(a) si pierde su contraseña.",
	"preset name": "nombre",
	"step password empty": "Faltan valores de la contraseña.",
	"step password too weak": "Su contraseña es poco segura. Debe añadir una mayúscula, un número, un carácter especial o una contraseña más larga.",
	"step password title": "Haga más segura su contraseña",
	"step password label": "contraseña",
	"step password input placeholder": "p.e. \"dEj875ghj9273;eR\"\n",
	"step password submit": "confirme",
	"step password show": "Mostrar la contraseña",
	"step password hide": "Oculte la contraseña",
	"step password description": "Su contraseña debe ser lo más complicada posible. Debe evitar que gente maliciosa pueda acceder a su cloud. Usar mayúsculas, cifras o carácteres especiales  es imperativo.",
	"step password server error": "Algo no funciona. Su contraseña no ha sido grabada.",
	"step infos title": "Complete su Cozy",
	"step infos description": "Cierta información se requiere para configurar su Cozy.",
	"step infos public_name label": "Usuario(a)",
	"step infos public_name placeholder": "El nombre público que se visualiza, Cozy lo usará para hablar con usted.",
	"step infos email label": "Email",
	"step infos email placeholder": "Utlizado por Cozy para reinicializar su contraseña.",
	"step infos timezone label": "Huso horario",
	"step infos timezone placeholder": "Su huso horario permite visualizar correctamente su agenda.",
	"step infos submit": "Confirmar",
	"step infos fetch data error": "Incapaz de recuperar datos del servidor.",
	"missing public_name": "Se requiere llenar el campo usuario(a).",
	"missing email": "Se requiere precisar su email.",
	"invalid email format": "Su dirección email no parece correcta.",
	"missing timezone": "Se requiere precisar su huso horario",
	"invalid timezone": "Su husohorario no parece correcto.",
	"step accounts title": "Su Cozy ha sido creada exitosamente!",
	"step accounts description line 1": "Ahora, le acompañaremos a conectar su Cozy a los servicios que le interesan.",
	"step accounts description line 2": "Finalmente, el objetivo de Cozy es ayudarle a recuperar sus datos!",
	"step accounts next": "Navegar",
	"myaccounts info": "Ahora usted puede acceder a su Cozy en cualquier momento, apoyando en el botón 'Continuar'",
	"myaccounts next": "Continuar",
	"step confirmation title": "¡ Bienvenido(a) a su cloud personal !",
	"step confirmation description line 1": "Su Cozy ya está lista.",
	"step confirmation description line 2": "Usted puede recuperar sus datos de muchos servicios, e instalar las aplicaciones que usted quiera desde nuestro almacén.",
	"step confirmation next": "Validar",
	"step server error": "Ha ocurrido un error al guardar su progresión. Volver a cargar la página resolverá el problema.",
	"preset name tip": "Este nombre aparece cuando se comparten archivos con otras personas o cuando se les invita a eventos.",
	"preset password": "contraseña",
	"preset password tip": "Se requiere una contraseña segura de al menos 8 caracteres (se recomienda el uso de caracteres especiales).",
	"preset timezone": "huso horario",
	"preset timezone tip": "Su huso horario le permite visualizar correctamente los eventos en su agenda.",
	"preset opt-in help": "Deseo ayudar a Cozy a mejorar la plataforma trasmitiéndole los datos estadísticos anonimos referidos a mi utilización.",
	"preset opt-out newsletter": "Quisiera que Cozy me informara de la evolución del producto (recomendado).",
	"import from google": "Importar mis datos desde mi cuenta Google",
	"import google account": "Sincronizar su cuenta Gmail & importar mis agendas, contactos y fotos desde Google",
	"import google account tip": "Se requiere iniciar una sesión en su cuenta Google para autorizar a su Cozy a acceder a sus datos alojados en Google",
	"leave google title": "Importar sus datos a Cozy",
	"leave google help me": "¡No sé qué hacer, por favor ayúdenme!",
	"leave google sign in content": "Acceda a su cuenta Google y autorice a su Cozy a acceder a los datos alojados en Google. Se visualizará una serie de caracteres compleja. Copiela. ",
	"leave google sign in": "Iniciar sesión en Google",
	"leave google code content": "Pegar el código enviado por Google aquí debajo:",
	"leave google code": "código google",
	"leave google url doc": "https://docs.cozy.io/en/mobile/import-google.html",
	"leave google choice": "Escoger lo que usted quiere hacer con los datos almacenados en los servidores de Google:",
	"leave google choice sync gmail": "GMail - Acceder a su email desde Cozy",
	"leave google choice contacts": "Contactos Google - Copiar en mi Cozy",
	"leave google choice calendar": "Agenda Google - Copiar en mi Cozy",
	"leave google choice photos": "Fotos Google - Copiar en mi Cozy",
	"leave google confirm": "Importar datos",
	"import error": "Un error se produjo al tratar de importar sus datos. Trate de hacerlo más tarde con una aplicación adecuada.",
	"login welcome user": "Bienvenido(a) %{username}",
	"login welcome anon": "Bienvenido(a)",
	"login enter your password": "Indique su contraseña para acceder a su Cozy",
	"login password": "contraseña",
	"login otp": "Código de autenticación",
	"login submit": "Conectarse",
	"login auth success": "Autenticación exitosa, ¡ adelante !",
	"login recover": "¿Ha olvidado su contraseña? Envíe un email para cambiarla.",
	"login recover busy": "Envío de un email que contiene instrucciones",
	"login recover sent title": "Email enviado",
	"login recover sent message": "Se le ha enviado un email con las instrucciones para restaurar su contraseña",
	"login recover error title": "Error al enviar el correo",
	"login recover error message": "Error al enviar el mensaje de recuperación de la contraseña, por favor chequear su MTA o ponerse en contacto con la administación del servidor",
	"login wrong password title": "Credenciales incorrectas",
	"login wrong password message": "La información que usted ha escrito son incorrectas. Por favor, ensaye de nuevo",
	"login server error": "Ha ocurrido un error, por favor vuelva a ensayar",
	"reset password request success title": "Email enviado.",
	"reset password request success message": "Revise sus emails, y siga las instrucciones para cambiar su contraseña.",
	"reset password request error": "Ha ocurrido un error., el email no ha sido enviado. Trate otra vez. Si el error persiste, contáctenos al contact@cozycloud.cc.",
	"reset welcome user": "Cambiar su contraseña",
	"reset enter your password": "%{username}, crear una nueva contraseña para recuperar el acceso a su Cozy.",
	"reset password": "contraseña",
	"reset submit": "restaurar su contraseña",
	"reset auth success": "contraseña restaurada",
	"reset wrong password title": "Su contraseña no ha podido restaurarse",
	"reset wrong password message": "La contraseña que usted ha introducido es incorrecta, o su token de restauración ha expirado",
	"reset password error invalid key": "Su solicitud de contraseña ha vencido. Por favor solicitela otra vez.",
	"reset password error password too weak": "Su contraseña es poco segura. Debe añadir una mayúscula, un número, un carácter especial o una contraseña más larga.",
	"setup title": "Estamos configurando su Cozy...",
	"setup message": "Ya casi puede disponer de su nube personal en donde podrá almacenar sus datos.",
	"setup on mobile title": "¡Utilizar Cozy en su periférico Android!",
	"setup on mobile message": "Descargar la aplicación mobile Cozy en Google Play:",
	"welcome title": "¡Felicitaciones! Usted acaba de tomar el control de sus datos.",
	"welcome message": "Con Cozy, ahora usted puede almacenar sus datos en su propio cloud personal.  A diferencia de la mayoría de los servicios cloud, ¡ ninguno de sus datos será analizado o explotado ! "
};


//////////////////
// WEBPACK FOOTER
// ./app/locales/es.json
// module id = 40
// module chunks = 0